"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellContent = exports.Cell = void 0;
const styles_1 = require("@mui/material/styles");
const TableCell_1 = __importStar(require("@mui/material/TableCell"));
exports.Cell = (0, styles_1.styled)(TableCell_1.default, {
    shouldForwardProp: (prop) => prop !== "isodd" && prop !== "isDeletable",
})((props) => ({
    [`&.${TableCell_1.tableCellClasses.body}`]: {
        fontSize: 14,
        borderBottom: "1px solid rgba(224, 224, 224, 1)",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: props.isodd
                ? (0, styles_1.alpha)(props.theme?.palette?.grayScale?.gray6, 0.2)
                : (0, styles_1.alpha)(props.theme?.palette?.grayScale?.gray5, 0.5),
        },
    },
}));
exports.CellContent = (0, styles_1.styled)("div", {
    shouldForwardProp: (prop) => prop !== "isValid",
})((props) => ({
    display: "flex",
    alignItems: "center",
    width: "100%",
    minWidth: "250px",
    maxHeight: "45px",
    justifyContent: "space-between",
    margin: "0.2rem 0",
    height: props.isValid ? "20px" : "40px",
    backfaceVisibility: "hidden",
    button: {
        margin: "0 0.2rem",
    },
}));
